"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _designLanguage = require("@doordash/design-language");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Titles = function Titles(_ref) {
  var isSubtextFirst = _ref.isSubtextFirst,
      textAlign = _ref.textAlign,
      hasSmallTitle = _ref.hasSmallTitle,
      subtextStringToDisplay = _ref.subtextStringToDisplay,
      title = _ref.title,
      isBelow = _ref.isBelow,
      allowTitleWrapping = _ref.allowTitleWrapping,
      allowSubtextWrapping = _ref.allowSubtextWrapping;
  var subTextProps = {
    color: _designLanguage.Text.Colors.TextTertiary,
    styles: hasSmallTitle ? _designLanguage.Text.Styles.NavBarCollapsedSubtitle : _designLanguage.Text.Styles.NavBarExpandedSubtitle,
    overflow: !allowSubtextWrapping ? _designLanguage.Text.Overflows.Truncate : undefined,
    textAlign: textAlign
  };
  var hasSubtext = subtextStringToDisplay && typeof subtextStringToDisplay !== 'undefined';
  var renderParentTitle = isSubtextFirst && hasSubtext;
  var renderSubtext = !isSubtextFirst && hasSubtext;
  return /*#__PURE__*/React.createElement(_designLanguage.StackChildren, {
    size: isBelow ? _designLanguage.StackChildren.Sizes.XxSmall : _designLanguage.StackChildren.Sizes.None
  }, renderParentTitle && /*#__PURE__*/React.createElement(_designLanguage.Text, subTextProps, subtextStringToDisplay), /*#__PURE__*/React.createElement(_designLanguage.Text, {
    textAlign: textAlign,
    tag: "h2",
    styles: hasSmallTitle ? _designLanguage.Text.Styles.NavBarCollapsedTitle : _designLanguage.Text.Styles.NavBarExpandedTitle,
    overflow: !allowTitleWrapping ? _designLanguage.Text.Overflows.Truncate : undefined
  }, title), renderSubtext && /*#__PURE__*/React.createElement(_designLanguage.Text, subTextProps, subtextStringToDisplay));
};

var _default = Titles;
exports["default"] = _default;